import { BATCH_MODE, CONVERSION_QUANTITY_MODE, CONVERSION_SOURCE_TYPE } from './activityBatchConversion.constants';
import { ConversionFormModel } from './activityBatchConversion.defaults';

const toPage = (value) => (Number.isInteger(Number(value)) && Number(value) > 0 ? Number(value) : null);

// DTO de un lote `convert` para v3. Solo viaja lo que la conversión necesita: v3 rechaza cualquier
// configuración de generación (topic, mint_pages, prompts, país, idioma, dificultad, tipos, objetivos).
export function serializeConversionBatch(values = {}) {
  const form = { ...ConversionFormModel, ...values };

  return {
    name: (form.name || '').trim(),
    mode: BATCH_MODE.CONVERT,
    source_type: CONVERSION_SOURCE_TYPE,
    source_ref_guid: form.source_ref_guid || null,
    source_url: form.source_url || null,
    page_from: toPage(form.page_from),
    page_to: toPage(form.page_to),
    process_whole_document: false,
    education_level_guid: form.educationLevel?.value ?? null,
    education_year_guid: form.educationYear?.value ?? null,
    discipline_guid: form.discipline?.value ?? null,
    quantity_mode: CONVERSION_QUANTITY_MODE,
  };
}

// POST crea el borrador con {id, name, mode}; el PATCH repite nombre y modo junto al resto de la
// configuración, porque tras un POST correcto el reintento salta el alta: sin `name` en el PATCH,
// un nombre corregido entre intentos no llegaría nunca al lote.
export function buildConversionRequests(values = {}) {
  const configuration = serializeConversionBatch(values);

  return {
    create: { name: configuration.name, mode: configuration.mode },
    patch: configuration,
  };
}
